<template>
    <TransitionModal>
        <Fixed
            v-if="isOpen"
            @close="close"
        >
            <ModalWithHeader
                :label="modalLabel"
                @close="close"
            >
                <AuthForm
                    :start-with-registration
                    :registration-errors="registrationErrors"
                    :registration-disabled
                    :registration-hide-inputs-if-logged
                    @register="$emit('register', $event)"
                    @login="$emit('login', $event)"
                    @login-error="$emit('loginError', $event)"
                >
                    <template #registration-title>
                        <slot name="registration-title" />
                    </template>

                    <template #registration-description>
                        <slot name="registration-description" />
                    </template>

                    <template #registration-contact>
                        <slot name="registration-contact" />
                    </template>

                    <template #registration-submit>
                        <slot name="registration-submit" />
                    </template>

                    <template #login-title>
                        <slot name="login-title" />
                    </template>
                </AuthForm>
            </ModalWithHeader>
        </Fixed>
    </TransitionModal>
</template>

<script setup lang="ts">
import type { ErrorCollectionWithTraces } from '@/helpers/errors'
import type {
    LoginResponseFailureFragment,
    LoginResponseSuccessFragment,
} from '@/graphql/api'

import AuthForm from './AuthForm.vue'
import TransitionModal from '@/components/layout/modal/TransitionModal.vue'
import Fixed from '@/components/layout/modal/Fixed.vue'
import ModalWithHeader from '@/components/layout/modal/ModalWithHeader.vue'

const { startWithRegistration = true } = defineProps<{
    isOpen: boolean
    modalLabel: string
    startWithRegistration?: boolean
    registrationErrors: ErrorCollectionWithTraces
    registrationDisabled?: boolean
    registrationHideInputsIfLogged?: boolean
}>()

const emit = defineEmits<{
    close: []
    login: [v: LoginResponseSuccessFragment]
    register: [successCallback: () => void]
    loginError: [v: LoginResponseFailureFragment]
}>()

const close = () => {
    emit('close')
}
</script>
